import styled from "styled-components";

export const RolesContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 24px 0;
  height: 100%;
`;

export const RolesGridWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  padding-right: 8px;

  @media (min-width: 769px) {
    & > * {
      flex: 0 0 calc(50% - 6px);
    }
  }

  @media (max-width: 768px) {
    flex-direction: column;
    & > * {
      flex: 0 0 100%;
    }
  }
`;

export const LoadMoreButtonContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  padding: 16px 0;

  & > button {
    padding: 8px 0px !important;
  }
`;

export const LoadingContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px 20px;
`;

